import { Row } from 'antd';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    min-height: 520px;
`;
